window.apisMailchimpRequestsDetailFormatter = function(value, row) {
    let html = '';
    if (row.request) {
        html += '<div class="form-group">';
        html += "<label>"+__("Request") + "</label>";
        html += '<textarea class="form-control" rows="3">'+row.request+"</textarea>";
        html += "</div>";
    }
    if (row.response) {
        html += '<div class="form-group">';
        html += "<label>"+__("Response")+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.response+"</textarea>";
        html += "</div>";
    }
    return html;
};

